<div class="CenterParagraphs">
	<p>Do you want to apply these changes to all existing entries or only to new students that are added to the group?</p>

	<p>If some of the students had their release changed manually (ex. one student gets to leave a couple</p>

	<p>minutes earlier than the rest of the group), updating existing entries will overwrite these changes.</p>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onYes()">Update All Existing Entries</button>
	<button class="btn btn-primary" (click)="onNo()">Only Apply to New Students Assigned to the Group</button>
	<button class="btn btn-primary" (click)="onCancel()">Cancel</button>
</div>
